export default {"src":"/_next/static/media/dinner_white.24b4aef5.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};